import React, { useEffect, useState } from 'react'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../../ui/table.tsx'
import { Checkbox } from '../../../../ui/checkbox.tsx'
import { Toaster, toast } from 'react-hot-toast';
import { Eye, Printer } from 'lucide-react';
import { useSelector } from 'react-redux'

const UserRights = ({users, onSuccess}) => {
    const doctypesTranslations = useSelector((state)=>state.doctypesTranslations)

    const [main_users, setmain_users] = useState([]);
    const [search_input, setsearch_input] = useState('');
    const [update_objects, setupdate_objects] = useState([]);

    const [is_loading, setis_loading] = useState(false);
    const [loading_percentage, setloading_percentage] = useState(0);

    const [update_rights_object, setupdate_rights_object] = useState([])

    const [amount_view_rows, setamount_view_rows] = useState(30);

    const language = JSON.parse(window.sessionStorage.getItem('user_data')).language || 'N'

    useEffect(()=>{
        if(Array.isArray(users)){
            setmain_users(users)
        }
    }, [users])

    const filterUsers = (users) => {
        let result = []

        result = users.filter(v => v.username.includes(search_input))

        return result;
    }

    function updateRights(userid, rightKey, rightValue) {
        setupdate_objects((prevStateArray) => {
            const existingUserIndex = prevStateArray.findIndex((user) => user.userid === userid);
        
            if (existingUserIndex !== -1) {
              // If the userid exists, update the existing object
              const updatedUser = {
                ...prevStateArray[existingUserIndex],
                [rightKey]: rightValue,
              };
              const newStateArray = [...prevStateArray];
              newStateArray[existingUserIndex] = updatedUser;
              return newStateArray;
            } else {
              // If the userid doesn't exist, add a new object
              const newUser = {
                userid,
                [rightKey]: rightValue,
              };
              return [...prevStateArray, newUser];
            }
        });
    }

    async function updateUserRightsOnAPI(stateArray, updateCallback, doneCallback) {
        try {
          const totalUsers = stateArray.length;
          let updatedCount = 0;
      
          for (const user of stateArray) {

            const rights = {...user}
            delete rights.userid
            
            const obj = {
                token: JSON.parse(window.sessionStorage.getItem("user_data")).token,
                userid: user.userid,
                rights: rights
            }

            const response = await fetch(`${process.env.REACT_APP_SERVER_LINK}userRightUpdate`, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(obj),
            });
            const data = await response.json()
      
            // Assuming your API returns a success status, you can count it as an updated user
            if (response.ok) {
              updatedCount++;
              updateCallback(updatedCount, totalUsers);
            }
          }
      
          doneCallback(updatedCount);
        } catch (error) {
          // Handle any errors that may occur during API calls
          console.error('Error updating user rights:', error);
        }
    }

    async function updateUserDoctypeRights(stateArray, updateCallback, doneCallback) {
        try {
            const totalUsers = stateArray.length;
            let updatedCount = 0;

            for(const user of stateArray) {
                let obj = {
                    ...user,
                    token: JSON.parse(window.sessionStorage.getItem("user_data")).token
                }
                delete obj.rights.apiuserid

                const response = await fetch(`${process.env.REACT_APP_SERVER_LINK}userRightUpdate`, {
                    method: 'PUT',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(obj),
                  });
                const data = await response.json()
                console.log(data)
            
                  // Assuming your API returns a success status, you can count it as an updated user
                if (response.ok) {
                    updatedCount++;
                    updateCallback(updatedCount, totalUsers);
                }
            }

            doneCallback(updatedCount)
        } catch (err) {

        }
    }

    const saveSettings = () => {
        setis_loading(true)
        toast.loading('Even geduld...', {id:'saveSettings'})

        if(update_objects.length > 0){
            try {
                updateUserRightsOnAPI(
                    update_objects, 
                    (count, total) => { setloading_percentage(Math.round((count/total)*100)) },
                    (updatedCount) => {  
                        onSuccess()
                        toast.success('Gebruikers geüpdatet', {id:'saveSettings'});
                        setloading_percentage(0)
                    }
                );
            } catch (error) {
                toast.error('Something went wrong', {id:'saveSettings'})
                console.log(error)
                
                setupdate_objects([])
                setloading_percentage(0)
            } finally {
                setis_loading(false); 
            }
        }

        if(update_rights_object.length > 0){
            try {
                setis_loading(true);
                updateUserDoctypeRights(
                    update_rights_object,
                    (count, total) => { setloading_percentage(Math.round((count/total)*100)) },
                    (updatedCount) => { setupdate_rights_object([]); setloading_percentage(0); toast.success('Gebruikers geüpdatet', {id:'saveSettings'}); }
                )
            } catch (error) {
                toast.error('Something went wrong', {id:'saveSettings'})
                console.log(error)
                
                setupdate_rights_object([])
                setloading_percentage(0)
            } finally {
                setis_loading(false)
            }
        }
    }

    const selectAllFilter = async (rightKey) => {
        const usersFilter = filterUsers(main_users);
        const toggleValue = !(update_objects.find(i => i.userid === usersFilter[0].apiuserid)?.[rightKey]) || !usersFilter[0].rights[rightKey];

        for(const user of usersFilter){
            await updateRights(user.apiuserid, rightKey, toggleValue)
        };
    }

    const selectAllDoctypeRights = async (doctype, right) => {
        const usersFilter = filterUsers(main_users);
        let toggleValue = true;
        try { 
            toggleValue = getDoctypeValue(usersFilter[0], doctype, right)
        } catch (e) {}

        console.log(toggleValue)
        for(const user of usersFilter){
            updateDoctypeRight(user, doctype, right, toggleValue) 
        }
    }

    const [selected_table, setselected_table] = useState('general');

    const getTableColumns = () => {
        const uniqueKeys = [];

        // Loop through the user-objects
        for (const user of main_users) {
            // Check if the user has "rights" and "doctypesrights"
            if (user.rights && user.rights.doctypesrights) {
                const doctypesrights = user.rights.doctypesrights;

                // Loop through the keys in doctypesrights
                for (const key in doctypesrights) {
                    if (!uniqueKeys.includes(doctypesrights[key].doctype) && !doctypesrights[key].doctype.includes('AFAC')) {
                        // Add the key to the uniqueKeys array if it's not already there
                        uniqueKeys.push(doctypesrights[key].doctype);
                    }
                }
            }
        }

        return uniqueKeys;
    }

    const getDoctypeValue = (user,doctype, right) => {
        const updatedObject = update_rights_object.find(i=>i.userid===user.apiuserid);
        if(updatedObject){
            if(updatedObject.rights.doctypesrights.find(i=>i.doctype===doctype)){
                return (updatedObject.rights.doctypesrights.find(i=>i.doctype===doctype)[right])
            }
        }

        const dc = user.rights.doctypesrights.find(i=>i.doctype===doctype);
        if(dc) { return user.rights.doctypesrights.find(i=>i.doctype===doctype)[right] }
        else { return false; }
    }

    const updateDoctypeRight = (user, doctype, right, current_value) => {
        setupdate_rights_object(prev => {
            const filter = prev.filter(i=>i.userid!==user.apiuserid);
            let rights = {...user.rights}
            let doctypeIndex = rights.doctypesrights.findIndex(i=>i.doctype===doctype)
            if(doctypeIndex > -1) { rights.doctypesrights[doctypeIndex] = {doctype:doctype, [right]:!current_value} }
            else { rights.doctypesrights.push({doctype:doctype, [right]:!current_value})}

            filter.push({userid:user.apiuserid, rights:rights})

            return filter
        })
    }

  return (
    <>
    <div className='mt-4'>
        <div className='flex justify-between'>
            <input onChange={({currentTarget})=>{setsearch_input(currentTarget.value)}} className='border p-2 focus:outline-none focus:border-green-700 duration-200' placeholder='Zoek een gebruiker...'/>
            <button onClick={()=>{saveSettings()}} disabled={(update_objects.length < 1 && !is_loading && update_rights_object.length < 1)} className='bg-green-700 border-green-700 text-white disabled:bg-neutral-100 disabled:border-neutral-100 disabled:text-neutral-500 min-h-10 border border-solid px-2 text-sm font-semibold hover:opacity-80'>
                {
                    is_loading 
                        ? `Even geduld ${loading_percentage}%`
                        : "Opslaan"
                    }
            </button>
        </div>

        <div className='border-b flex gap-2 mb-2 mt-4'>
            <button onClick={()=>{setselected_table('general')}} className={`${selected_table === 'general' && '!text-green-700 font-semibold'}   duration-100 text-neutral-400  text-md font-medium py-3 px-2`}>Algemeen</button>
            <button onClick={()=>{setselected_table('doctypes')}} className={`${selected_table === 'doctypes' && '!text-green-700 font-semibold'} duration-100 text-neutral-400 text-md font-medium py-3 px-2`}>Documenttypes</button>
        </div>
        
        {selected_table === 'general' && 
        <div className='border mt-4'>
            <Table>
                <TableHeader>
                    <TableRow className='bg-neutral-100'>
                        <TableHead className='font-semibold uppercase text-sm text-green-900'>E-mailadres</TableHead>
                        <TableHead onClick={()=>{ selectAllFilter('infofiche') }} className='cursor-pointer font-semibold uppercase text-sm text-green-900 duration-200 hover:underline'>Infofiche pagina</TableHead>
                        <TableHead onClick={()=>{ selectAllFilter('emailnotice') }} className='cursor-pointer font-semibold uppercase text-sm text-green-900 duration-200 hover:underline'>Infofiche mail</TableHead>   
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {Array.isArray(main_users) && filterUsers(main_users).slice(0,amount_view_rows).map((user, index)=> {
                        return (
                        <TableRow className='hover:bg-green-50' key={index}>
                            <TableCell>{user.username}</TableCell>
                            <TableCell><Checkbox checked={update_objects.find(i => i.userid === user.apiuserid)?.infofiche} onCheckedChange={(checked) => { updateRights(user.apiuserid, 'infofiche', checked) }} defaultChecked={user.rights.infofiche || false}/></TableCell>
                            <TableCell><Checkbox checked={update_objects.find(i => i.userid === user.apiuserid)?.emailnotice} onCheckedChange={(checked) => { updateRights(user.apiuserid, 'emailnotice', checked) }} defaultChecked={user.rights.emailnotice || false}/></TableCell>
                        </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        </div>
        }

        {selected_table === 'doctypes' &&
        <div className='border mt-4 max-w-[calc(100vw-26.7rem)] overflow-auto'>
           
            <Table>
                <TableHeader>
                    <TableRow className='bg-neutral-100'>
                        <TableHead className='font-semibold uppercase text-sm text-green-900'>E-mailadres</TableHead>
                        {getTableColumns().map((doctype, index) => { 
                            return (
                                <TableHead className='font-semibold uppercase text-sm text-green-900' key={index}>
                                    <div onClick={()=>{selectAllDoctypeRights(doctype, 'view')}} className='flex justify-center text-center cursor-pointer hover:underline'>{doctypesTranslations ? (doctypesTranslations[doctype] ? doctypesTranslations[doctype][language] : doctype ) : doctype}</div>
                                </TableHead>
                            )
                        })}
                    </TableRow>
                </TableHeader>
                <TableBody>
                    
                    {Array.isArray(main_users) && filterUsers(main_users).slice(0,amount_view_rows).map((user, index)=> {
                            return (
                            <TableRow className='hover:bg-green-50' key={index}>
                                <TableCell>{user.username}</TableCell>
                                {getTableColumns().map((doctype, index) => { 
                                    return (
                                        <TableCell key={index}>
                                            <div className='flex justify-center'><button onClick={()=>{updateDoctypeRight(user, doctype, 'view', getDoctypeValue(user,doctype,'view'))}} className={`${getDoctypeValue(user,doctype,'view') ? 'opacity-100 text-green-700' : 'opacity-30'}`}><Eye /></button></div>
                                        </TableCell>
                                    )
                                })}
                            </TableRow>
                            )
                    })}
                </TableBody>
            </Table>
        </div>
        }
        
        {amount_view_rows < main_users.length && 
        <div className='flex justify-center mt-4'>
            <button onClick={()=>{setamount_view_rows(prev=>prev+15)}} className='bg-green-700 text-white p-3 px-4 font-semibold'>Meer gebruikers inladen</button>
        </div>
        }
        

    </div>
    </>
  )
}

export default UserRights